import * as React from 'react';
import { Linked, useIO, useModel } from '@type-r/react';
import { CollapsableSection, CompactTextArea, Flex, FormInput, Loading, PopupIODialog } from 'lqx-react/src';
import { attributes, Events, subsetOf } from '@type-r/models';
import { makeStyles } from '@material-ui/core';
import { InvoiceItem } from '../../api';
import { InvoiceItemGrid } from '../../common';

const State = attributes({
    sentDate: Date,
    comment: String,
    invoiceItems: [InvoiceItem],    
    selected: subsetOf('invoiceItems')
})
type State = InstanceType<typeof State>;

export const MarkAsSentDialog = ({ $isOpen, relationshipId }: {
    $isOpen: Linked<boolean>,
    relationshipId: number
}) => {

    const state = useModel(State)

    const isReady = useIO(async () => {
        const invoiceItems = await InvoiceItem.fetchInvoiceItems('out-of-inb', relationshipId);
        state.invoiceItems.set(invoiceItems, { parse: true });
        state.selected.set(state.invoiceItems.models);
    });

    let styles = useStyles();

    const confirmInvoices = async () => {
        if (state && state.selected && state.selected.length) {
            const payload = {
                relationshipId: relationshipId,
                invoiceIds: Array.from(state.selected.map((i: InvoiceItem) => i.id)),
                comments: state.comment,
                invoiceSentDate: state.sentDate
            };    
            await InvoiceItem.executeAction('mark-as-sent-confirmed', payload);
        }
    }

    const markAsSent = async () => {
        if (state && state.selected && state.selected.length) {
            const payload = {
                relationshipId: relationshipId,
                invoiceIds: Array.from(state.selected.map((i: InvoiceItem) => i.id)),
                comments: state.comment,
                invoiceSentDate: state.sentDate
            };    
            await InvoiceItem.executeAction('mark-as-sent', payload);
        }
    }

    const isValid = () => {
        return state.selected.length;
    }

    return (
        <PopupIODialog
            $isOpen={$isOpen}
            title="Mark Invoices as Sent"
            actionLabel="Mark as Sent"
            altActionLabel="Mark as Sent & Confirmed"
            success="Invoices marked as sent"
            disabled={!isValid()}
            doIO={markAsSent}
            altDoIO={confirmInvoices}
            onSuccess={() => Events.trigger("Landing:notSentChanged")}
        >

            <FormInput date $value={state.$.sentDate} maxDate={new Date()} label="Invoice sent Date" />
            <Flex className={styles.popup}>
                {
                    isReady ? 
                    <CollapsableSection title={`Select Invoices`}>
                        <InvoiceItemGrid invoiceItems={state.invoiceItems} $selected={state.$.selected as any}/>
                    </CollapsableSection>
                    : <Loading />
                }
                <CompactTextArea label="Comments" $value={state.$.comment} />
            </Flex>
        </PopupIODialog>
    );

}

const useStyles = makeStyles({
    popup: {
        minHeight: 400
    }
});
